import type { UrlWithParsedQuery } from 'node:url'

import { SortOrder } from './api/v1/types'
import { jsonParse } from './serialization'

export interface Query<TFilter, TSortOrder = SortOrder> {
    filter?: TFilter
    /** @DATA_FORMAT NON_NEGATIVE_INTEGER */
    skip?: number
    /** @DATA_FORMAT NON_NEGATIVE_INTEGER */
    limit?: number
    order?: TSortOrder
}

export function toQueryParams(q: Query<any, any>): { q: string } {
    return { q: JSON.stringify(q) }
}

export function fromQueryParams<TFilterType, TSortOrderType = SortOrder>(q: UrlWithParsedQuery['query']) {
    if (!q.q) {
        return {} as Query<TFilterType, TSortOrderType>
    }
    let obj
    try {
        obj = jsonParse(q.q as string)
    } catch (e) {
        // Try to decodeURIComponent first to support older API clients
        obj = jsonParse(decodeURIComponent(q.q as string))
    }
    return obj as Query<TFilterType, TSortOrderType>
}

export function fromCustomQueryParams<QueryType>(q: UrlWithParsedQuery['query']) {
    if (!q.q) {
        return {} as QueryType
    }
    let obj
    try {
        obj = jsonParse(q.q as string)
    } catch (e) {
        // Try to decodeURIComponent first to support older API clients
        obj = jsonParse(decodeURIComponent(q.q as string))
    }
    return obj as QueryType
}
